import { ArrowLeft } from 'lucide-react';
import { ButtonLink } from '@/components/ui/Button';
import { Logo } from '@/components/brand/Logo';
import { useT } from '@/i18n';

export function NotFound() {
  const t = useT();
  return (
    <div className="grain grid min-h-dvh place-items-center bg-bg px-4">
      <div className="flex max-w-md flex-col items-center gap-6 text-center">
        <Logo as="text" className="text-2xl" />
        <h1 className="display display-lg text-ink">{t('notFound.title')}</h1>
        <p className="text-sm leading-relaxed text-muted">
          {t('notFound.body', { hash: '#' })}
        </p>
        <ButtonLink
          to="/"
          variant="secondary"
          leadingIcon={<ArrowLeft className="size-4" aria-hidden="true" />}
        >
          {t('notFound.home')}
        </ButtonLink>
      </div>
    </div>
  );
}
